export default __webpack_public_path__ + "static/media/People.2fa041c6.jpg";